import { render, staticRenderFns } from "./AddCustomerView.vue?vue&type=template&id=69779769&scoped=true&"
import script from "./AddCustomerView.vue?vue&type=script&lang=js&"
export * from "./AddCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerView.vue?vue&type=style&index=0&id=69779769&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69779769",
  null
  
)

export default component.exports